import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#002C77",
        secondary: "#009DE0",
        accent: "#A4C8E1",
        error: "#b71c1c",
      },
    },
  },
});
